module.exports = __webpack_public_path__ + "static/media/helpIcon.3d793613.svg";